import {
  DeleteTwoTone,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  SyncOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  InputRef,
  notification,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnType,
  Tooltip,
} from "antd";
import React from "react";
import { useTheme } from "../../../Context/ThemeContext";
import { useClient } from "../../../Context/ClientContext";
import search from "../../../Images/search.svg";
import { AddLedger } from "./AddLedger";
import { GroupTypes } from "../../../Services/ChartofAccountServicesNew";
import { ColumnsType } from "antd/es/table";
import { Utils } from "../../../../Utilities/Utils";
import { FilterDropdownProps } from "antd/es/table/interface";
import LedgerService, {
  LedgerStatus,
  MasterName,
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import { NavLink, useLocation } from "react-router-dom";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { IndianStates } from "../../../../Types/CommonConstants";
import "jspdf-autotable";
import InvoiceExportService from "../../../Services/InvoiceExportDetails";
import { useUser } from "../../../../Context/UserContext";
import { GSTTypeOptions } from "../../Clients/Clients";
import ImportPartyModal from "../../Parties/ImportPartyModal";
import ImportLedgerModal from "./ImportLedgerModal";
import { premissionLedgerAndGroup } from "../../Users/Roles/UserSecurityFind";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import CbImportButton from "../../../Components/ui/Button/CbImportButton";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

interface IItemListData {
  sNo: number;
  key: string;
  parent: string;
  id: string;
  ledgerName: string;
  aliasName: string;
  parentGroup: string;
  balance: string;
  numberBalance: number;
  gstin: string;
  state: IndianStates;
  name: string;
  email: string;
  phone: string;
  system: boolean;
  editable: boolean;
  status: LedgerStatus;
  isActive: boolean;
}
// interface IItemListData1 {
//   ledgerName: string;
//   parentGroup: string;
//   gstin: string;
//   contPerson: string;
//   email: string;
//   phone: string;
// }

type NotificationType = "success" | "error";

type DataIndex = keyof IItemListData;
// type DataIndex1 = keyof IItemListData1;

const LedgerTable: React.FC<{
  showName: string;
  ledgerByGroupsType: SearchLedgerByGroupsTypes;
}> = (props) => {
  console.log("props", props);
  const { themeData } = useTheme();
  const location = useLocation();
  const { currentClient } = useClient();
  const { getAllIndStates, clientSpecificRole } = useUser();
  const stateOptions: any = getAllIndStates();
  const [api, contextHolder] = notification.useNotification();
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [openModel, setOpenModel] = React.useState<{
    open: boolean;
    id: any;
  }>({
    open: false,
    id: "",
  });
  const [open, setOpen] = React.useState<any>(false);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [serchAllField, setSerchAllField] = React.useState<string>("");
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [ledgerData, setLedgerData] = React.useState<any[]>([]);
  const [filterGroupTypes, setFilterGroupTypes] = React.useState<GroupTypes>();
  const [filter, setfilter] = React.useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [exportType, setExportType] = React.useState<number>(-1);
  const [ledgerName, setLedgerName] = React.useState<string>();
  const [exportLedgerData, setExportLedgerData] = React.useState<any[]>([]);
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [searchColumns, setSearchColumns] = React.useState<any>({
    // {
    //   ledgerName: string;
    //   parentGroup: string;
    //   gstin: string;
    //   name: string;
    //   email: string;
    //   phone: string;
    // }
    ledgerName: "",
    parentGroup: "",
    gstin: "",
    name: "",
    email: "",
    phone: "",
  });
  const [selectIndState, setSelectIndState] = React.useState<IndianStates>(
    IndianStates.Unspecified
  );
  const [confirmationActive, setConfirmationActive] =
    React.useState<boolean>(false);
  const [confirmationDeleted, setConfirmationDelete] =
    React.useState<boolean>(false);
  const [selectChange, setSelectChange] = React.useState<string>("");
  const [ledgerStatus, setLedgerStatus] = React.useState<LedgerStatus>(
    LedgerStatus.active
  );
  // const [searchedColumn, setSearchedColumn] = React.useState("");
  const searchInput = React.useRef<InputRef>(null);
  const searchSelect = React.useRef<any>(null);
  const [onlyAmountValue, setOnlyAmountValue] = React.useState<boolean>(false);
  const [openDropdown, setOpenDropdown] = React.useState<DataIndex | null>(
    null
  );
  const [searchColumnCount, setSearchColumnCount] = React.useState<number>(0);
  const openNotification = (type: NotificationType, message: string) => {
    api[type]({
      message: "",
      description: message,
      duration: 2,
      closeIcon: false,
      style: {
        width: 350,
      },
    });
  };

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    let prevValue = searchColumns[dataIndex];
    let newValue = selectedKeys;

    // text/number inputs -> pick first value and trim
    if (
      dataIndex === "ledgerName" ||
      dataIndex === "parentGroup" ||
      dataIndex === "gstin" ||
      dataIndex === "email" ||
      dataIndex === "name" ||
      dataIndex === "phone" ||
      dataIndex === "state"
    ) {
      newValue =
        selectedKeys && selectedKeys[0] ? String(selectedKeys[0]).trim() : "";
    }

    // text/number: empty + no previous -> do nothing
    if (newValue === "" && (!prevValue || String(prevValue).trim() === "")) {
      confirm();
      setOpenDropdown(null);
      return;
    }
    // text/number: unchanged value -> do nothing
    if (
      typeof prevValue === "string" &&
      newValue === String(prevValue).trim()
    ) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    let newSearchColumns = { ...searchColumns };
    console.log("newSearchColumns", newSearchColumns);

    switch (dataIndex) {
      case "ledgerName":
      case "parentGroup":
      case "gstin":
      case "email":
      case "name":
      case "state":
        newSearchColumns[dataIndex] = newValue || "";
        break;
    }

    // set or unset searchColumnCount based on previous and new values
    if (
      (!prevValue ||
        (Array.isArray(prevValue)
          ? prevValue.length === 0
          : String(prevValue).trim() === "")) &&
      ((Array.isArray(newValue) && newValue.length > 0) ||
        (!Array.isArray(newValue) && newValue !== ""))
    ) {
      setSearchColumnCount((prev) => prev + 1);
    } else {
      setSearchColumnCount((prev) => prev - 1);
    }

    // switch (dataIndex) {
    //   case "ledgerName":
    //     setSearchColumns({
    //       ...searchColumns,
    //       ledgerName: selectedKeys[0],
    //     });
    //     break;
    //   case "parentGroup":
    //     if (selectedKeys[0] || searchColumns.parentGroup) {
    //       setSearchColumns({ ...searchColumns, parentGroup: selectedKeys[0] });
    //     }
    //     break;
    //   case "gstin":
    //     if (selectedKeys[0] || searchColumns.gstin) {
    //       setSearchColumns({ ...searchColumns, gstin: selectedKeys[0] });
    //     }
    //     break;
    //   case "email":
    //     if (selectedKeys[0] || searchColumns.email) {
    //       setSearchColumns({ ...searchColumns, email: selectedKeys[0] });
    //     }
    //     break;
    //   case "name":
    //     if (selectedKeys[0] || searchColumns.name) {
    //       setSearchColumns({ ...searchColumns, name: selectedKeys[0] });
    //     }
    //     break;
    //   case "phone":
    //     if (selectedKeys[0] || searchColumns.phone) {
    //       setSearchColumns({ ...searchColumns, phone: selectedKeys[0] });
    //     }
    //     break;
    //   case "state":
    //     setSelectIndState(selectedKeys[0]);
    //     break;
    // }
    setSearchColumns(newSearchColumns);
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();
    // console.log("dataIndex", dataIndex);

    let prevValue = searchColumns[dataIndex];

    // console.log("newValue111", prevValue, dataIndex);

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);
    }
    if (prevValue) {
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }

    // switch (dataIndex) {
    //   case "ledgerName":
    //     if (searchColumns.ledgerName) {
    //       setSearchColumns({
    //         ...searchColumns,
    //         ledgerName: "",
    //       });
    //     }
    //     break;
    //   case "parentGroup":
    //     if (searchColumns.parentGroup) {
    //       setSearchColumns({ ...searchColumns, parentGroup: "" });
    //     }
    //     break;
    //   case "gstin":
    //     if (searchColumns.gstin) {
    //       setSearchColumns({ ...searchColumns, gstin: "" });
    //     }
    //     break;
    //   case "email":
    //     if (searchColumns.email) {
    //       setSearchColumns({ ...searchColumns, email: "" });
    //     }
    //     break;
    //   case "name":
    //     if (searchColumns.name) {
    //       setSearchColumns({ ...searchColumns, name: "" });
    //     }
    //     break;
    //   case "phone":
    //     if (searchColumns.phone) {
    //       setSearchColumns({ ...searchColumns, phone: "" });
    //     }
    //     break;
    //   case "state":
    //     setSelectIndState(IndianStates.Unspecified);
    //     break;
    // }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<IItemListData> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        {dataIndex === "state" ? (
          <Select
            allowClear
            ref={searchSelect}
            showSearch
            placeholder="Select.."
            value={selectedKeys[0]}
            options={Object.entries(stateOptions)?.map(([key, x]: any) => ({
              value: x?.id,
              label: x?.name,
            }))}
            onChange={(e) => setSelectedKeys(e ? [e] : [])}
            filterOption={(input: string, option: any) =>
              (option?.label?.toString() ?? "")
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            // style={{
            //   width: "100%",
            // }}
            style={{ marginBottom: 8, display: "block" }}
          />
        ) : (
          <Input
            ref={searchInput}
            placeholder={`Search..`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            style={{ marginBottom: 8, display: "block" }}
          />
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    filterDropdownOpen: openDropdown === dataIndex,
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "state") {
            searchSelect.current?.focus(); // Use focus for Select component
          } else {
            searchInput.current?.select(); // Use select for Input component
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  // --------- Table list data ---------
  React.useEffect(() => {
    // debugger;

    const getListData = async (
      search: string,
      groupSearch: string,
      start: number,
      length: number,
      ledgerStatus?: LedgerStatus,
      GstTxt?: string,
      selectIndState?: IndianStates,
      contPerson?: string,
      email?: string,
      contPhone?: string,
      onlyAmountValue?: boolean
      // StateTxt?: IndianStates,
    ) => {
      try {
        if (exportType < 1) {
          setLoading(true);
        }

        const data = await LedgerService.getLedgerList(
          currentClient?.id!,
          start,
          length,
          search,
          groupSearch,
          filter.sortCol,
          filter.sortDir,
          "",
          ledgerStatus,
          GstTxt,
          selectIndState,
          contPerson,
          email,
          contPhone,
          onlyAmountValue,
          props.ledgerByGroupsType
          // serchAllField
        );

        if (data?.items) {
          let lederList = data?.items?.map((r: any, i: any) => {
            let defaultContact = r?.contactInformation?.find(
              (x: any) => x?.isDefault === true
            );
            // console.log("defaultConatct", defaultConatct);
            return {
              key: i,
              sNo: r?.sno,
              system: r?.system,
              id: r?.id,
              ledgerName: r?.ledgerName,
              aliasName: r?.aliasName,
              parentGroup: r?.groupName,
              numberBalance: r?.balance,
              balance:
                r?.balance > 0
                  ? Utils.getFormattedNumber(r?.balance) + " Dr."
                  : r?.balance < 0
                  ? Utils.getFormattedNumber(Math.abs(r?.balance)) + " Cr."
                  : Utils.getFormattedNumber(r.balance),
              gstin: r?.gstin,
              gstType: r?.gstType,
              state: r?.state,
              status: r?.status,
              email: defaultContact?.email,
              phone: defaultContact?.phone,
              isActive: r?.isActive,
            };
          });
          const exportWithoutDeleted = lederList
            ?.filter((x: any) => x?.status !== LedgerStatus.deleted)
            ?.map((item: any, index: number) => ({
              ...item,
              sNo: index + 1,
            }));
          if (exportType >= 1) {
            setExportLedgerData(exportWithoutDeleted);
            if (exportType === 1) {
              exportCsv(exportWithoutDeleted);
            } else if (exportType === 2) {
              exportPDF(exportWithoutDeleted);
            } else if (exportType === 3) {
              exportExcel(exportWithoutDeleted);
            }
          } else {
            setLoading(false);
            setTotalRecords(data?.totalRecords);
            setLedgerData(lederList);
          }
        } else {
          // setLedgerData(res.items);
          setLedgerData([]);
          setLoading(false);
          setTotalRecords(data?.totalRecords);
          // console.log("Error", res);
        }
      } catch (err: any) {
        setLoading(false);
        // console.log("Error", err);
      }
    };

    if (currentClient?.id && (exportType === -1 || exportType)) {
      getListData(
        serchAllField,
        searchColumns.parentGroup,
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        ledgerStatus,
        searchColumns.gstin,
        selectIndState,
        searchColumns?.name, // Contect Name
        searchColumns?.email, // Contect Email
        searchColumns?.phone, // Contect Phone
        onlyAmountValue

        // filterGroupTypes,
        // searchColumns,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    trigger,
    filter,
    searchColumns,
    serchAllField,
    ledgerStatus,
    selectIndState,
    onlyAmountValue,
    exportType,
    props.ledgerByGroupsType,
  ]);

  const permissionEdit = premissionLedgerAndGroup(
    currentClient?.id!,
    props.ledgerByGroupsType,
    IPermissionActionType.Edit,
    MasterName.Ledger,
    clientSpecificRole()
  );

  const permissionDelete = premissionLedgerAndGroup(
    currentClient?.id!,
    props.ledgerByGroupsType,
    IPermissionActionType.Delete,
    MasterName.Ledger,
    clientSpecificRole()
  );

  const permissionAdd = premissionLedgerAndGroup(
    currentClient?.id!,
    props.ledgerByGroupsType,
    IPermissionActionType.Add,
    MasterName.Ledger
  );

  // --------- Table Columns  ---------
  const columns: ColumnsType<IItemListData> = [
    {
      title: "S.No.",
      dataIndex: "sNo",
      key: "sNo",
      width: "5%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sNo}
        </Skeleton>
      ),
    },
    {
      title: `${props.showName}'s Name (Alias/Short Name)`,
      dataIndex: "ledgerName",
      key: "LedgerName",
      // width: "19%",
      sorter: true,
      defaultSortOrder: "ascend",
      // width: width <= 1440 ? "8%" : "15%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <NavLink
            to={
              props.ledgerByGroupsType === SearchLedgerByGroupsTypes.PartiesOnly
                ? `/billing/clients/${currentClient?.id}/party/partyLedger/${record?.id}`
                : props.ledgerByGroupsType ===
                  SearchLedgerByGroupsTypes.AllExpenses
                ? `/billing/clients/${currentClient?.id!}/expensesLedger/${
                    record?.id
                  }`
                : props.ledgerByGroupsType ===
                  SearchLedgerByGroupsTypes.IndirectIncomeOnly
                ? `/billing/clients/${currentClient?.id!}/incomeLedger/${
                    record?.id
                  }`
                : props.ledgerByGroupsType ===
                  SearchLedgerByGroupsTypes.DebtorsOnly
                ? `/billing/clients/${currentClient?.id!}/sales/customerLedger/${
                    record?.id
                  }`
                : props.ledgerByGroupsType ===
                  SearchLedgerByGroupsTypes.CreditorsOnly
                ? `/billing/clients/${currentClient?.id!}/purchase/supplierLedger/${
                    record?.id
                  }`
                : `/billing/clients/${currentClient?.id}/master/ledger/${record?.id}`
            }
          >
            {record.aliasName
              ? `${record?.ledgerName} (${record?.aliasName})`
              : record?.ledgerName}
          </NavLink>
        </Skeleton>
      ),
      // ...getColumnSearchProps("ledgerName"),
    },
    {
      title: `${props.showName}'s Group`,
      dataIndex: "parentGroup",
      key: "parentGroup",
      width: "20%",
      // sorter: true,
      // width: width <= 1440 ? "8%" : "15%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.parentGroup}
        </Skeleton>
      ),
      ...getColumnSearchProps("parentGroup"),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "Balance",
      width: "12%",
      sorter: true,
      align: "right",
      // onFilter: (value: string, record) => {
      //   return set
      // },
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: {
              display: "flex",
              justifyContent: "end",
            },
          }}
          title={false}
        >
          <div
            style={{
              color:
                Utils.getNumber(record?.numberBalance) >= 0 ? "green" : "red",
            }}
          >
            {record.balance}
          </div>
        </Skeleton>
      ),
      // ...getColumnSearchProps("balance"),
    },
    // {
    //   title: "GSTIN",
    //   dataIndex: "gstin",
    //   key: "gstin",
    //   width: "10%",
    //   sorter: true,
    //   render: (_, record) => (
    //     <Skeleton
    //       active
    //       loading={loading}
    //       paragraph={{ rows: 1 }}
    //       title={false}
    //     >
    //       {record?.gstin}
    //     </Skeleton>
    //   ),
    //   ...getColumnSearchProps("gstin"),
    // },
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   key: "state",
    //   width: "12%",
    //   // width: width <= 1440 ? "12%" : "10%",
    //   sorter: true,
    //   render: (_, record) => (
    //     <Skeleton
    //       active
    //       loading={loading}
    //       paragraph={{ rows: 1 }}
    //       title={false}
    //     >
    //       {getIndianStates(record?.state)}
    //     </Skeleton>
    //   ),
    //   ...getColumnSearchProps("state"),
    // },

    {
      title: "Action",
      dataIndex: "isActive",
      width: "7%",
      align: "center",
      render: (val, record) => (
        <Skeleton
          active
          paragraph={{
            rows: 1,
          }}
          loading={loading}
          title={false}
          className="cursor"
        >
          <div
            style={{ display: "flex", justifyContent: "flex-Star", gap: 12 }}
          >
            {(record.status === LedgerStatus.active ||
              record.status === LedgerStatus.deactive) && (
              <Tooltip title={val ? "Make inactive" : "Make active"}>
                <Checkbox
                  checked={record?.isActive}
                  onChange={(e: any) => {
                    console.log(e.target.checked);
                    setOpenModel({ ...openModel, id: record?.id });
                    setConfirmationActive(true);
                    setSelectChange(record?.isActive ? "de-active" : "active");
                    setLedgerName(record?.ledgerName);
                  }}
                />
              </Tooltip>
            )}
            {record.status === LedgerStatus.active && permissionEdit && (
              <Tooltip
                title={
                  record?.system
                    ? `Default  ${props.showName} are not editable`
                    : "Edit"
                }
                placement="top"
                color={record?.system ? "rgb(216 207 207)" : "#444653"}
              >
                <EditOutlined
                  // className="ca-edit-btn"
                  style={{
                    color: record?.system ? "rgb(216 207 207)" : "#444653",
                  }}
                  onClick={() => {
                    !record?.system &&
                      setOpenModel({
                        open: true,
                        id: record?.id,
                      });
                    setLedgerName(record?.ledgerName);
                  }}
                />
              </Tooltip>
            )}
            {(record.status === LedgerStatus.active ||
              record.status === LedgerStatus.deactive) &&
              permissionDelete && (
                <Tooltip
                  title={
                    record?.system
                      ? `Default  ${props.showName} cannot be deleted`
                      : "Delete"
                  }
                  placement="top"
                  color={record?.system ? "rgb(216 207 207)" : "red"}
                >
                  <DeleteTwoTone
                    className="ca-delete-btn cursor"
                    twoToneColor={
                      record?.system ? "rgb(216 207 207)" : "#ff879d"
                    }
                    onClick={() => {
                      if (!record?.system) {
                        setOpenModel({ ...openModel, id: record?.id });
                        setConfirmationDelete(true);
                        setLedgerName(record?.ledgerName);
                      }
                    }}
                  />
                </Tooltip>
              )}
            {record.status === LedgerStatus.deleted && permissionAdd && (
              <Tooltip title="Revive Ledger">
                <SyncOutlined
                  style={{ color: "green" }}
                  // className="ca-delete-btn cursor"
                  onClick={() => {
                    setSelectChange("revive");
                    setConfirmationActive(true);
                    setOpenModel({ ...openModel, id: record?.id });
                    setLedgerName(record?.ledgerName);
                  }}
                />
              </Tooltip>
            )}
          </div>
        </Skeleton>
      ),
    },
  ];

  if (
    // props.ledgerByGroupsType === SearchLedgerByGroupsTypes.All ||
    props.ledgerByGroupsType === SearchLedgerByGroupsTypes.PartiesOnly ||
    props.ledgerByGroupsType === SearchLedgerByGroupsTypes.CreditorsOnly ||
    props.ledgerByGroupsType === SearchLedgerByGroupsTypes.DebtorsOnly
  ) {
    columns.splice(
      3,
      0,
      {
        title: "Party Type",
        dataIndex: "gstType",
        key: "GSTType",
        render: (record: any, _: any) => (
          <>
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              {GSTTypeOptions.find((gstrec) => gstrec.key === record)?.label}
            </Skeleton>
          </>
        ),
      },
      {
        title: "Contact No.",
        dataIndex: "phone",
        // key: "group_Name",
        width: "12%",
        // width: width <= 1440 ? "12%" : "10%",
        // sorter: true,
        render: (_, record) => (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            {record?.phone}
          </Skeleton>
        ),
        ...getColumnSearchProps("phone"),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "14%",
        // sorter: true,
        render: (_, record) => (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            {record?.email}
          </Skeleton>
        ),
        ...getColumnSearchProps("email"),
      }
    );
  }

  //----- Table Ascending & Desending Order -----
  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "number",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
    // console.log("sort", sort);

    // if (sort?.group_Type) {
    // console.log("sort", sort?.group_Type);
    // setFilterGroupTypes(sort?.group_Type);
    // }
  };

  //----- Short-Cut for Open Model TimeCondition -----

  // const exportCsv = () => {
  //   LedgerService.exportCsv(
  //     currentClient?.id!,
  //     serchAllField,
  //     searchColumns.parentGroup,
  //     filter.sortCol,
  //     filter.sortDir,
  //     "",
  //     ledgerStatus,
  //     searchColumns.gstin,
  //     selectIndState,
  //     searchColumns?.contPerson,
  //     searchColumns?.contPhone
  //     // invoiceStatus
  //   )
  //     .then((res: any) => {
  //       if (res) {
  //         console.log("download sucess");
  //       }
  //     })
  //     .catch((ex: any) => {
  //       openNotification("error", ex.message);
  //     });
  // };

  const generateFooterRow = (columns: any) => {
    return columns?.map((col: any) => "");
  };

  let path = `${props.showName}s' List`;
  const columnsA = [
    "S.No.",
    `${props.showName}'s Name`,
    `${props.showName}'s Group`,
    ...(props.ledgerByGroupsType === SearchLedgerByGroupsTypes.DebtorsOnly ||
    props.ledgerByGroupsType === SearchLedgerByGroupsTypes.CreditorsOnly ||
    props.ledgerByGroupsType === SearchLedgerByGroupsTypes.PartiesOnly
      ? ["Party Type", "Contact No.", "Email"]
      : []),
    "Balance",
  ];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sNo,
    [`${props.showName}'s Name`]: (item: any) => item?.ledgerName,
    [`${props.showName}'s Group`]: (item: any) => item?.parentGroup,
    Balance: (item: any) => item?.balance || 0,
    "Contact No.": (item: any) => item?.phone,
    "Party Type": (item: any) =>
      GSTTypeOptions.find((gstrec) => gstrec.key === item?.gstType)?.label ||
      "",
    Email: (item: any) => item?.email,
  };
  const exportCsv = (exportData: any[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (exportData: any[]) => {
    // InvoiceExportService.generatePDF(
    //   exportData,
    //   currentClient?.businessName,
    //   columnsA,
    //   fieldMapping,
    //   generateFooterRow,
    //   "",
    //   path
    // );
    InvoiceExportService.AutoDownloadPDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: any[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportLedgerData.length > 0) {
              exportCsv(exportLedgerData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportLedgerData.length > 0) {
              exportPDF(exportLedgerData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportLedgerData.length > 0) {
              exportExcel(exportLedgerData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        // marginTop: "6px",
        marginTop: 35,
        // padding: "48px 0px 0px 0px",
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <React.Fragment>
        <Row
          justify="space-between"
          style={
            {
              // paddingTop: props?.partyId ? "10px" : "0px"
              // marginTop: 10,
              // padding: "0px 0px 10px 0px",
            }
          }
          // style={{ position: "sticky",zIndex:1, top: 0, padding: "5px" }}
        >
          <Col>
            <Space size={width <= 768 ? 465 : 5}>
              {permissionAdd && (
                <Col>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpenModel({ open: true, id: "" })}
                  >
                    {props.showName}
                  </Button>
                </Col>
              )}
              <Col>
                {ledgerData?.length === 0 ||
                ledgerStatus === LedgerStatus.deleted ||
                ledgerData?.filter((x) => x?.status === LedgerStatus.deleted)
                  ?.length === ledgerData.length ? (
                  <>
                    <Button
                      type="default"
                      icon={<DownloadOutlined />}
                      // onClick={() => exportCsv()}
                      disabled
                    >
                      Export
                    </Button>
                  </>
                ) : (
                  <>
                    <Popover
                      content={content}
                      placement="rightTop"
                      trigger="hover"
                    >
                      <Button
                        type="default"
                        icon={<DownloadOutlined />}
                        // onClick={() => exportCsv()}
                      >
                        Export
                      </Button>
                    </Popover>
                  </>
                )}
              </Col>
              {premissionLedgerAndGroup(
                currentClient?.id!,
                props.ledgerByGroupsType,
                IPermissionActionType.Add,
                MasterName.Ledger
              ) && (
                <Col>
                  {location?.pathname ===
                  `/billing/clients/${currentClient?.id}/master/ledger` ? (
                    <>
                      <Button
                        icon={<UploadOutlined />}
                        onClick={() => {
                          setOpen("ImportLedgerModal");
                        }}
                      >
                        Import Ledger
                      </Button>
                    </>
                  ) : (
                    <CbImportButton
                      name={
                        "Import " +
                        (props?.showName === "Party"
                          ? "Parties"
                          : props?.showName + "s")
                      }
                      onClick={() => {
                        setOpen("ImportPartyModal");
                      }}
                    />
                    // <Button
                    //   icon={<UploadOutlined />}
                    //   onClick={() => {
                    //     setOpen("ImportPartyModal");
                    //   }}
                    // >
                    //   Import{" "}
                    //   {props?.showName === "Party"
                    //     ? "Parties"
                    //     : props?.showName + "s"}
                    // </Button>
                  )}
                </Col>
              )}
              {/* <Button
              style={{
                marginLeft: "10px",
              }}
              icon={<ArrowDownOutlined />}
            >
              Export
            </Button> */}
            </Space>
          </Col>

          <Col
            style={{
              marginTop: width <= 768 ? 15 : "",
            }}
          >
            <Row gutter={width <= 768 ? 98 : 8}>
              <Col>
                <Input
                  allowClear
                  style={{ width: "200px", border: "1px solid #f1f3ff" }}
                  placeholder={`Search ${props.showName}..`}
                  onChange={(e: any) => {
                    setLoading(true);
                    if (!e.cancelable) {
                      //console.log("typeing user............");
                      const serchAllField = setTimeout(() => {
                        setPage(1);
                        setSerchAllField(e.target.value);
                      }, 1000);
                      return () => clearTimeout(serchAllField);
                    } else {
                      // console.log("Click cancle............");
                      setSerchAllField(e.target.value);
                    }
                    setExportLedgerData([]);
                    setExportType(-1);
                  }}
                  suffix={
                    loading || serchAllField ? (
                      ""
                    ) : (
                      <img alt="Search.." src={search} />
                    )
                  }
                />
              </Col>

              <Col>
                <Select
                  defaultValue={false}
                  style={{ width: "200px" }}
                  onChange={(e: boolean) => {
                    setPage(1);
                    setOnlyAmountValue(e);
                    setExportLedgerData([]);
                    setExportType(-1);
                  }}
                  options={[
                    {
                      value: false,
                      label: `All  ${
                        props?.showName === "Party"
                          ? "Parties"
                          : props?.showName + "s"
                      }`,
                      title: "",
                    },
                    {
                      value: true,
                      label: "Having Transactions Only",
                      title: "",
                    },
                  ]}
                />
              </Col>

              <Col>
                <Select
                  defaultValue={LedgerStatus.active}  
                  style={{ width: "110px" }}
                  onChange={(e: LedgerStatus) => {
                    setPage(1);
                    setLedgerStatus(e);
                    setExportLedgerData([]);
                    setExportType(-1);
                  }}
                  options={[
                    { value: LedgerStatus.all, label: "All", title: "" },
                    { value: LedgerStatus.active, label: "Active", title: "" },
                    {
                      value: LedgerStatus.deactive,
                      label: "De-Active",
                      title: "",
                    },
                    { value: LedgerStatus.deleted, label: "Delete", title: "" },
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        {/* --------- Table --------- */}
        <div>
          <Table
            columns={columns}
            dataSource={
              loading
                ? (Array.from({ length: pageSize }, (_, index) => ({
                    key: `loading-${index}`,
                  })) as IItemListData[])
                : ledgerData
            }
            locale={{
              triggerDesc: "",
              triggerAsc: "",
              cancelSort: "",
            }}
            onChange={tableSort}
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
            // rowSelection={rowSelection}
            pagination={{
              total: totalRecords,
              current: page,
              pageSize: pageSize,
              showSizeChanger: true,
              onChange: (page: number, pageSize: number) => {
                setPage(page);
                setPageSize(pageSize);
                setExportType(-1);
              },
              pageSizeOptions: tablePageSizeOptions,
              showTotal: (totalRecords, page) =>
                `${page[0]}-${page[1]} of ${totalRecords} items`,
            }}
            // scroll={
            //   pageSize > 15
            //     ? { x: 900, y: window.innerHeight - 300 }
            //     : { x: 1000 }
            // }
            scroll={
              pageSize > 15 ? { x: 1000, y: window.innerHeight - 320 } : {}
            }
          />
        </div>
        {openModel.open && (
          <AddLedger
            openDrawer={openModel.open}
            id={openModel?.id}
            setOpenDrawer={() => setOpenModel({ open: false, id: "" })}
            setTrigger={() => setTrigger(!trigger)}
            showName={props.showName}
            type={props.ledgerByGroupsType ?? SearchLedgerByGroupsTypes.All}
          />
        )}

        {open === "ImportPartyModal" && (
          <ImportPartyModal
            onCancel={() => {
              setOpen("");
            }}
          />
        )}
        {confirmationActive && (
          <ConfirmationModal
            open={confirmationActive}
            onNo={() => setConfirmationActive(false)}
            onYes={async () =>
              await LedgerService.makeLedgerActiveInactive(
                currentClient?.id!,
                openModel?.id
              )
                .then((res: any) => {
                  if (res.result) {
                    console.log("res", res);
                    setTrigger((x: boolean) => !x);
                    openNotification(
                      "success",
                      `Ledger ${
                        selectChange === "de-active"
                          ? "deactivated"
                          : selectChange === "active"
                          ? "activated"
                          : "revived"
                      } successfully.`
                    );
                    setConfirmationActive(false);
                  } else if (res?.message) {
                    openNotification("error", res?.message);
                    setConfirmationActive(false);
                  }
                })
                .catch((err: any) => {
                  openNotification("error", err);
                  setConfirmationActive(false);
                  console.log("error", err);
                })
            }
            text={`Are you sure you want to ${selectChange} ${props.showName} "${ledgerName}"?`}
          />
        )}
        {confirmationDeleted && (
          <ConfirmationModal
            open={confirmationDeleted}
            onNo={() => setConfirmationDelete(false)}
            onYes={async () =>
              await LedgerService.deleteLedgerMaster(
                currentClient?.id!,
                openModel?.id
              )
                .then((res: any) => {
                  if (res.result) {
                    console.log("res", res);
                    setTrigger((x: boolean) => !x);
                    openNotification("success", "Ledger deleted successfully.");
                    setConfirmationDelete(false);
                  } else if (res?.message) {
                    debugger;
                    openNotification("error", res?.message);
                    setConfirmationDelete(false);
                  }
                })
                .catch((err: any) => {
                  openNotification("error", err);
                  // setConfirmationDelete(false);
                  console.log("error", err);
                })
            }
            text={`Are you sure you want to delete  ${props.showName} "${ledgerName}"?`}
            loading={false}
          />
        )}
        {open === "ImportLedgerModal" && (
          <ImportLedgerModal
            onCancel={() => {
              setOpen("");
            }}
          />
        )}
      </React.Fragment>
      {contextHolder}
    </Card>
  );
};

export default LedgerTable;
